<template>
  <div id="graph_1" class="graph-container">
    <div class="container-top-row">
      <div class="title-graph"><span>Series Temporales</span></div>
      <div class="button-close" @click="closeSerie">
        <span class="draw-x">X</span>
      </div>
    </div>
    <div class="container-main-row">
      <div class="draw-graph" v-if="serie_status == 4">
        <Plotly  :data="data" :layout="layout" :scrollZoom="true" :displaylogo="false" id="plotly" :modeBarButtonsToRemove="['resetScale2d', 'hoverCompareCartesian', 'hoverClosestCartesian']"></Plotly>
      </div>
      <div class="no-graph" v-else>
        <info v-if="serie_status < 4"></info>
      </div>
      <div class="main-row-buttons">
        <div class="button-graph" v-if="serie_status == 0 || serie_status == 4" @click="clickSerieTemporalMM()">Serie temporal MM</div>
        <div class="button-graph-disabled " v-else disabled>Serie temporal MM</div>
        <div class="button-graph mt-3" v-if="serie_status == 0 || serie_status == 4" @click="startDraw()">Dibujar transecto</div>
        <div class="button-graph-disabled mt-3" v-else disabled>Dibujar transecto</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import { mapGetters } from 'vuex'
import info from "@/components/mapparams/info.vue"

export default {
  name: 'graph_2',
  components: {
    Plotly,
    info
  },
  computed: {
    ...mapGetters(
      "map_params", {
      results_graph_MM: 'results_graph_MM',
      selected_param: 'selected_param',
      stations_or_density: 'stations_or_density',
      campaign_datas_filtered: 'campaign_datas_filtered'
    }
    ),
    serie_status: {
        set (status) { this.$store.dispatch('map_params/change_serie_status', status); },
        get () { return this.$store.state.map_params.serie_status }
    },
    transect_points: {
        set (points) { this.$store.commit('map_params/set_transect_points', points); },
        get () { return this.$store.state.map_params.transect_points }
    },
  },

  watch: {
    'results_graph_MM': function () {
      this.loadGraph()
    },
    'selected_param': function () {
      this.changeSelectedParamData()
    },
    'campaign_datas_filtered': function () {
      this.getCampaingDates()
    },
  },

  data() {
    return {
      loading: true,
      campaign_dates: [],
      data:  [
        {
          z: [],
          x: [],
          y: [],
          type: 'heatmap',
          colorbar: {
            title: 'ODO mg/L',
          },
          hovertemplate: '%{z:.2f}<extra></extra>',
        },
        {
          z: [],
          x: [],
          y: [],
          hoverinfo: 'skip',
          type: 'heatmap',
          colorscale: [
            [0, 'rgba(165,0,38,0)'],
            [1, 'rgba(255,255,255,1)']
          ]
        }
      ],
      layout: {
        title: 'Concentración de oxígeno',
        autosize: true,
        yaxis: {
          mirror: true,
          ticks: 'outside',
          showline: true,
          // autorange: 'reversed',
          title: {
            text: 'Profundidad [m]'
          }
        },
        xaxis: {
          mirror: true,
          ticks: 'outside',
          showline: true,
          type:"date",
          title: {
            text: 'Campañas'
          }
        },
        // plot_bgcolor:"#052030",
        paper_bgcolor: "#FFF3",
        dragmode: 'pan',
        modebar: {
          bgcolor: 'rgba(0,0,0,0)',
          color: '#9590a0',
          activecolor: '#5570a0',
          orientation: 'v'
        },
        height: 200,
        margin: {
          t: 30,
          r: 160,
          b: 40
        },
        hoverlabel: {
          font: {
            color: 'white'
          }
        }
      }
    };

  },
  created(){
    this.getCampaingDates()
  },
  mounted() {
    this.changeSelectedParamData()
  },

  methods: {
    startDraw: function(){
      this.serie_status = 1
    },
    clickSerieTemporalMM: function () {
      this.serie_status = 3
      this.transect_points = []
      this.$store.dispatch('map_params/change_serie_temporal_MM', [])
      
    },
    loadGraph: function () {
      this.data[0].x = this.results_graph_MM.dates
      this.data[0].y = this.results_graph_MM.depth
      this.data[0].z = this.results_graph_MM.values
      // this.data[0].zsmooth = "best"
      //this.data[0].colorscale = 'Portland'
      // this.data[0].reversescale = true 

     
      this.data[1].showscale = false
      this.data[1].zsmooth = "best"
      this.layout.xaxis.range = [this.campaign_dates[0], this.campaign_dates[this.campaign_dates.length - 1]]

      // this.layout.xaxis.range = [0,this.results_graph_1.dist[this.results_graph_1.dist.length-1]]
      // this.layout.yaxis.range = [7,0]


    },
    getCampaingDates: function (){
      this.campaign_datas_filtered.forEach(campaign => {
        this.campaign_dates.push(campaign.date)
      });
      //console.log(this.campaign_dates[0],this.campaign_dates[this.campaign_dates.length - 1])
    },
    changeSelectedParamData: function () {
      let unit = ''
      let title = ''
      switch (this.selected_param) {
        case 1:
          unit = 'ODO mg/L'
          title = 'Concentración de oxígeno'
          this.data[0].zmin = 0
          this.data[0].zmax = 15
          this.data[0].hovertemplate = '%{z:.2f}<extra></extra> mg/L'
          this.data[0].colorscale =  [
                              ['0.0', 'rgb(153,0,0)'],
                              ['0.076', 'rgb(255,0,0)'],
                              ['0.14', 'rgb(255,204,0)'],
                              ['0.162', 'rgb(160,255,255)'],
                              ['0.3255132', 'rgb(178,175,246)'],
                              ['0.45747801', 'rgb(147,142,246)'],
                              ['0.56944949', 'rgb(120,113,246)'],
                              ['0.72727273', 'rgb(51,0,153)'],
                              ['1.0', 'rgb(51,0,102)']
                            ]
          break
        case 2:
          unit = 'ODO %'
          title = 'Porcentaje de oxígeno'
          this.data[0].zmin = 0
          this.data[0].zmax = 200
          this.data[0].hovertemplate = '%{z:.2f}<extra></extra> %'
          this.data[0].colorscale = [
                              ['0.0', 'rgb(255,255,255)'],
                              ['0.1202346', 'rgb(153,204,204)'],
                              ['0.22340843', 'rgb(0,204,255)'],
                              ['0.31378299', 'rgb(102,51,255)'],
                              ['0.4340176', 'rgb(51,102,153)'],
                              ['0.55718475', 'rgb(153,0,153)'],
                              ['0.68328446', 'rgb(102,0,102)'],
                              ['0.82697947', 'rgb(79,0,102)'],
                              ['1.0', 'rgb(51,0,102)']
                            ]
          break
        case 3:
          unit = 'CHL µg/L'
          title = 'Clorofila'
          this.data[0].zmin = 0
          this.data[0].zmax = 200
          this.data[0].hovertemplate = '%{z:.2f}<extra></extra> µg/L'
          this.data[0].colorscale = [
                              ['0.0', 'rgb(247,252,253)'],
                              ['0.01371429', 'rgb(255,255,153)'],
                              ['0.02742857', 'rgb(204,255,102)'],
                              ['0.06857143', 'rgb(185,211,158)'],
                              ['0.13714286', 'rgb(97,191,174)'],
                              ['0.20571429', 'rgb(82,186,152)'],
                              ['0.27428571', 'rgb(65,174,118)'],
                              ['0.34285714', 'rgb(35,139,69)'],
                              ['0.41142857', 'rgb(0,51,51)'],
                              ['0.68571429', 'rgb(255,102,0)'],
                              ['0.73684211', 'rgb(102,51,255)'],
                              ['1.0', 'rgb(102,51,153)']
                            ]
          break
        case 4:
          unit = 'SAL PSU'
          title = 'Salinidad'
          this.data[0].zmin = 30
          this.data[0].zmax = 56
          this.data[0].hovertemplate = '%{z:.2f}<extra></extra> PSU'
          this.data[0].colorscale = [
                              ['0.0', 'rgb(252,255,233)'],
                              ['0.07692308', 'rgb(255,255,233)'],
                              ['0.22660049', 'rgb(233,255,233)'],
                              ['0.31715768', 'rgb(162,216,225)'],
                              ['0.41756823', 'rgb(87,128,255)'],
                              ['0.58565306', 'rgb(51,0,204)'],
                              ['0.81051208', 'rgb(153,0,204)'],
                              ['1.0', 'rgb(255,0,0)']
                            ]
          break
      }
      this.data[0].colorbar.title = unit
      this.layout.title = title
      this.loading = false
 
      this.loadGraph()
    },

    closeSerie: function(){
      this.$store.dispatch('map_params/change_stations_or_density', "serie_temp")
    },

  }

};
</script>

<style>
.graph-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 50px;
  z-index: 10000000;
  width: calc(100% - 440px);
  height: 25%;
  background-color: rgb(242, 247, 248);
  margin-left: 20px;
  /*margin-top: 25%;*/
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  /* border: 3px solid rgb(44,188,188);*/
  overflow: hidden;
}
.title-graph {
  color: #34596B;
  font-weight: bold;
  font-size: 0.8rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.draw-graph {
  position: relative;
  width: 100%;
  bottom: calc(100% - 205px);
}
.no-graph {
  position: relative;
  width: 100%;
  display: flex; 
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0,0,0,0.15);
  border-radius: 5px;
  height: 200px;
  margin-left: 20px;
  margin-top: 30px;
}
.loading-icon {
  height: 50%;
  width: auto;
}
.button-close {
  position: relative;
  float: right;
  margin-right: 2px;
  width: 25px;
  height: 25px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  text-align: center;
  box-shadow: 0px 2px 5px rgba(0,0,0,0.3);
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  background-color: white;
}
.draw-x {
  color:rgba(63,148,155,1);
}
.draw-x:hover {
  color:rgb(90, 196, 206);
}
.loading-gif {
  width: 120px;
  height: 100px;
  margin-left: 40%;
  margin-top: 14%;
}

#plotly {
  margin-top: 2%;
  margin-left: 2%;
  width: 97%;
  background-color: white;
}

.container-top-row {
  background-color: #c6dde2;
  padding: 5px;
  display: flex;
  flex-direction: row;
}
.container-main-row {
  display: flex;
  flex-direction: row;
}
.main-row-buttons {
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 240px;
}


/* BUTTONS */
.button-graph {
    padding: 12px;
    border-radius: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    cursor: pointer;
    box-shadow: 4px 4px 5px #C6DDE2, 
        -5px -5px 6px #ffffff;
    color: #447998;
}
.button-graph:hover {
    color:#1CBBB4;
    box-shadow: 1px 1px 3px #C6DDE2, 
        -5px -5px 6px #ffffff;
}
.button-graph-disabled {
  padding: 12px;
  border-radius: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  color: #C6DDE2FF;
  box-shadow: 1px 1px 3px #C6DDE2, 
        -5px -5px 6px #ffffff;
}

/* **********   ANIMATIONS   ************ */
.button-graph{
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/mapparams/graph_2.vue